// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --padding-bottom: 15%;
}

ion-spinner {
  margin: 10px 0;
}

h5 {
  font-weight: bold;
}

.attendee-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 3px 0;
  margin: 0 20px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
}
.attendee-item:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}
.attendee-item .user-icon-container {
  display: flex;
}
.attendee-item .user-icon-container .user-icon {
  font-size: 36px;
  color: #ed143d;
}
.attendee-item ion-label {
  flex: 1;
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.added-header {
  display: flex;
  align-items: flex-end;
  gap: 15px;
  margin: 0 20px;
}
.added-header h5 {
  flex: 1;
  margin: 8px 0 6px;
}

.attendee-columns {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}
.attendee-columns .column-header {
  width: 64px;
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #666666;
  margin-bottom: 6px;
}
.attendee-columns .check-cell {
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: 0;
  padding: 4px 0;
  cursor: pointer;
}
.attendee-columns .check-cell ion-icon {
  font-size: 26px;
  color: #c7c7c7;
}
.attendee-columns .check-cell.active ion-icon {
  color: #ed143d;
}
.attendee-columns .remove-cell {
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.attendee-columns .remove-cell ion-icon {
  font-size: 24px;
  color: #8a8a8a;
  cursor: pointer;
}

ion-searchbar {
  --background: white;
  --icon-color: #ed143d;
  --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);
  padding: 5px 10px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/add-attendee/add-attendee.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AAAA;EAIE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAAF;AAVE;EACE,gCAAA;AAYJ;AAFE;EACE,aAAA;AAIJ;AAHI;EACE,eAAA;EACA,cAAA;AAKN;AAFE;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,cAAA;AAGF;AAFE;EACE,OAAA;EACA,iBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAGF;AAFE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAIJ;AAFE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAIJ;AAHI;EACE,eAAA;EACA,cAAA;AAKN;AAHI;EACE,cAAA;AAKN;AAFE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIJ;AAHI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAKN;;AAAA;EACE,mBAAA;EACA,qBAAA;EACA,8CAAA;EACA,iBAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;AAGF","sourcesContent":["ion-content {\n  --padding-bottom: 15%;\n}\n\nion-spinner {\n  margin: 10px 0;\n}\nh5 {\n  font-weight: bold;\n}\n.attendee-item {\n  &:not(:last-child) {\n    border-bottom: 1px solid #e0e0e0;\n  }\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 3px 0;\n  margin: 0 20px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 4px;\n  .user-icon-container {\n    display: flex;\n    .user-icon {\n      font-size: 36px;\n      color: #ed143d;\n    }\n  }\n  ion-label {\n    flex: 1;\n    min-width: 0;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n}\n\n.added-header {\n  display: flex;\n  align-items: flex-end;\n  gap: 15px;\n  margin: 0 20px;\n  h5 {\n    flex: 1;\n    margin: 8px 0 6px;\n  }\n}\n\n.attendee-columns {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n  .column-header {\n    width: 64px;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    font-size: 12px;\n    font-weight: 600;\n    color: #666666;\n    margin-bottom: 6px;\n  }\n  .check-cell {\n    width: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: none;\n    border: 0;\n    padding: 4px 0;\n    cursor: pointer;\n    ion-icon {\n      font-size: 26px;\n      color: #c7c7c7;\n    }\n    &.active ion-icon {\n      color: #ed143d;\n    }\n  }\n  .remove-cell {\n    width: 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    ion-icon {\n      font-size: 24px;\n      color: #8a8a8a;\n      cursor: pointer;\n    }\n  }\n}\n\nion-searchbar {\n  --background: white;\n  --icon-color: #ed143d;\n  --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);\n  padding: 5px 10px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
